//#region assets/view-transitions.ts
(function() {
	if (shouldDisableCrossDocumentViewTransitions()) disableCrossDocumentViewTransitions();
	const viewTransitionRenderBlocker = document.getElementById("view-transition-render-blocker");
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || isLowPowerDevice()) viewTransitionRenderBlocker?.remove();
	else {
		const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());
		setTimeout(() => {
			viewTransitionRenderBlocker?.remove();
		}, RENDER_BLOCKER_TIMEOUT_MS);
	}
	const idleCallback = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;
	window.addEventListener("pageswap", async (event) => {
		const { viewTransition } = event;
		if (shouldSkipViewTransition(viewTransition)) {
			/** @type {ViewTransition | null} */ viewTransition?.skipTransition();
			return;
		}
		["pointerdown", "keydown"].forEach((eventName) => {
			document.addEventListener(eventName, () => {
				viewTransition.skipTransition();
			}, { once: true });
		});
		document.querySelectorAll("[data-view-transition-type]:not([data-view-transition-triggered])").forEach((element) => {
			element.removeAttribute("data-view-transition-type");
		});
		const transitionType = document.querySelector("[data-view-transition-triggered]")?.getAttribute("data-view-transition-type");
		if (transitionType) {
			viewTransition.types.clear();
			viewTransition.types.add(transitionType);
			sessionStorage.setItem("custom-transition-type", transitionType);
		} else {
			viewTransition.types.clear();
			viewTransition.types.add("page-navigation");
			sessionStorage.removeItem("custom-transition-type");
		}
	});
	window.addEventListener("pagereveal", async (event) => {
		const { viewTransition } = event;
		if (shouldSkipViewTransition(viewTransition)) {
			/** @type {ViewTransition | null} */ viewTransition?.skipTransition();
			return;
		}
		const customTransitionType = sessionStorage.getItem("custom-transition-type");
		if (customTransitionType) {
			viewTransition.types.clear();
			viewTransition.types.add(customTransitionType);
			await viewTransition.finished;
			viewTransition.types.clear();
			viewTransition.types.add("page-navigation");
			idleCallback(() => {
				sessionStorage.removeItem("custom-transition-type");
				document.querySelectorAll("[data-view-transition-type]").forEach((element) => {
					element.removeAttribute("data-view-transition-type");
				});
			});
		} else {
			viewTransition.types.clear();
			viewTransition.types.add("page-navigation");
		}
	});
	/**
	* @param {ViewTransition | null} viewTransition
	* @returns {viewTransition is null}
	*/
	function shouldSkipViewTransition(viewTransition) {
		return !(viewTransition instanceof ViewTransition) || isLowPowerDevice() || prefersReducedMotion() || shouldDisableCrossDocumentViewTransitions();
	}
	/**
	* Detect in-app WebViews known to mishandle cross-document view transitions.
	*
	* Reports of in-app browsers WebViews failing to paint during cross-document (MPA) View
	* Transitions that can freeze or white-screen the storefront on navigation.
	* June 2026 testing.  The common factor is the Android System WebView (Chromium WebView),
	* whose UA carries the `; wv)` token inside the platform parenthetical.
	* Remove check if ever resolved.
	*
	* We can't import this from utilities.ts here (this file runs before modules),
	* so the equivalent detector in utilities.ts must be kept in sync.
	* @param {string} [userAgent=navigator.userAgent] - User-agent string to test.
	* @returns {boolean} True if running inside an unsupported in-app WebView.
	*/
	function shouldDisableCrossDocumentViewTransitions(userAgent = navigator.userAgent) {
		const ua = userAgent || "";
		const androidWebView = /\bAndroid\b/i.test(ua) && /;\s?wv\)/i.test(ua);
		const knownInAppBrowser = /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(ua);
		return androidWebView || knownInAppBrowser;
	}
	/**
	* Disable cross-document (MPA) View Transitions for the current document.
	*
	* Overrides the standard `@view-transition { navigation: auto }` CSS opt-in
	* and drops the render-blocking `<link rel="expect">` so a stalled transition
	* can never hold first paint (the white-screen symptom).
	*/
	function disableCrossDocumentViewTransitions() {
		const style = document.createElement("style");
		style.textContent = "@view-transition { navigation: none; }";
		(document.head || document.documentElement).appendChild(style);
		document.getElementById("view-transition-render-blocker")?.remove();
	}
	function prefersReducedMotion() {
		return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	}
	function isLowPowerDevice() {
		return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
	}
})();
//#endregion
